import React, { lazy, Suspense } from "react";

const ExportMap = lazy(() => import("../../../Components/ExportMap"));

const Seventh_About_Section = () => {
  return (
    <section className="w-full py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Remove the text-center div from here */}

        <Suspense
          fallback={
            <div className="w-full flex items-center justify-center" style={{ height: "700px" }}>
              Loading Map...
            </div>
          }
        >
          <ExportMap />
        </Suspense>
      </div>
    </section>
  );
};
export default Seventh_About_Section;